// register component(s) with react habitat
import withLazyUnveil from '@src/scripts/hoc/withLazyUnveil';

export default {
	InfomaterialForm: withLazyUnveil( {
		loadComponent: () =>
			import(
				/* webpackChunkName: "InfomaterialForm" */
				'./index'
			),
		height: 1277,
		mobileHeight: 1440,
	} ),
};
